import React, { useContext, useState } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Form, FormLabel, Modal, Button } from 'react-bootstrap';
import PortfolioContext from '../../context/context';
import emailjs from 'emailjs-com';
import Title from '../Title/Title';
import Result from './Result'

const Contact = () => {
  const { contact } = useContext(PortfolioContext);
  const { cta, btn, email } = contact;
  const [result,showResult] = useState(false)

  const sendEmail = (e)=> {
    e.preventDefault();

    emailjs.sendForm('service_8jazlvb', 'template_zd1vgkq', e.target, 'user_Cy5kjIVy7HqR7DxUksARB')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
      showResult(true)
  }

  return (
    <section id="contact">
      <Container>
        <Title title="Contact" />
        <Fade bottom duration={1000} delay={800} distance="30px">
          <div className="contact-wrapper">
          <Form onSubmit={sendEmail}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Control type="name" name="fullName" placeholder="name" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Control type="email" name="email" placeholder="name@example.com" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1" >
              <Form.Control
                as="textarea"
                name="message"
                placeholder="Leave a comment here"
              />
            </Form.Group>
            <button
              target="_blank"
              type="submit"
              rel="noopener noreferrer"
              className="cta-btn cta-btn--resume"
              href={email ? `mailto:${email}` : 'https://github.com/cobidev/react-simplefolio'}
            >
              {btn || "Let's Talk"}
            </button>
          </Form>
          </div>
        </Fade>
      </Container>
      {result ? 
        <Modal show={result} onHide={()=>showResult(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Message sent</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Your message has been sent Successfully</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" style={{color:'white', fontSize:'1.3rem', width:'100%'}} onClick={()=>showResult(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
        :null}
    </section>
  );
};

export default Contact;
